<template>
  <div class="a-vs-b-progress-bar">
    <span>{{ currentData }}%</span>
    <div class="a-vs-c--progress-wrap">
      <object :height="currentData + '%'"></object>
    </div>
    <span>{{over+.5}}</span>
    <div class="a-vs-c--progress-wrap">
      <object :height="100 - currentData + '%'"></object>
    </div>
    <span>{{ 100 - currentData }}%</span>
  </div>
</template>
<script>

export default {
  props: {
    currentData: {
      type: Number,
      required: true
    },
    over: {
      type: Number,
      required: true
    }
  }

}
</script>
